module.exports = __webpack_public_path__ + "img/coin.52bad0c1.svg";